import React, { useState, useEffect, useMemo } from 'react';
import { Trans } from 'react-i18next';
import { NotificationManager } from 'react-notifications';
import { Col, Row, Button, Table, Input as UpdateInput } from 'reactstrap';
import { FormGroup as UpdateFormGroup } from 'components/common';
import BackButton from 'components/refactoring/BackButton';
import { Page, DatePicker } from 'components/common';
import { useOrganisationContext, useUserContext } from "hooks";
import { ApiClient, } from "services";
import { Control, LocalForm } from 'react-redux-form';
import { handleFilesCountUpdate, formatNumber } from 'services/util';
import {
  useForm,
  FormProvider,
  useFieldArray,
  useWatch,
} from "react-hook-form";
import {
  FormGroup,
  Input,
} from "components/react-hook-form";
import InputFilesForm from 'components/common/InputFilesForm';

const RequestDuringAudit = ({ t, match }) => {

  const [auditDateRange, setDateRange] = useState();

  const methods = useForm({
    mode: "onBlur",
    defaultValues: {
      checkbox: false,
    }
  });
  const { reset, control, setValue, handleSubmit, watch, getValues } = methods;


  const { fields, remove, append } = useFieldArray({
    control,
    name: "account_file",
    keyName: "key",
  });
  const count_progress = useWatch({
    control,
    name: "account_file",
  })
  const { selectedOrganisation } = useOrganisationContext();
  const { user } = useUserContext();

  const client = ApiClient();
  const [filter, setFilter] = useState('');
  const [uploadedFilesCount, setUploadedFilesCount] = useState([]);

  const auditor_permission = useMemo(() => {
    return user?.permissions?.includes("access_audit_report");;
  }, [user?.permissions]);

  const progress = useMemo(
    () => (formatNumber((count_progress?.filter(item => item?.audit_requirements_account.length > 0)?.length / count_progress?.length) * 100, "0.0")) || 0,
    [count_progress]
  );

  useEffect(() => {
    addRow();
    fetchData();
    fetchAllFilesData();
  }, []);

  const connectedOrg = selectedOrganisation ? selectedOrganisation?.id : 0;
  const year_id = match.params.id;
  const request_during_audit_id = match.params?.request_during_audit_id;

  const addRow = () => {
    append({
      // id: rows.length + 1,
      file_name: '',
      comment: '',
      uploaded: false,
      upload_date: '',
      uploaded_by: '',
      upload_file: null,
      progress: 0,
      status: false
    });
  };


  const handleRequestSubmit = async (values) => {

    const payload = {
      progress: progress,
      add_year: year_id,
      account_file: values?.account_file
    };


    try {
      const response = await client.post(`/audit_reports/${connectedOrg}/during_audit/${year_id}/create_request_during_audit`, payload);
      const id = response?.data?.id
      NotificationManager.success(t("Saved successfully"));
      window.location.replace(`/reports/audit_reports/request_during_audit/${year_id}/${id}`)
    } catch (error) {
      NotificationManager.error(error?.response?.data?.error || t("Something went wrong"));
    }
  };

  const handleUpdateDateRange = async (values) => {
    const payload = {
      start_date: values.start_date,
      deadline: values.deadline,
      selected_year: year_id
    };

    try {
      const response = await client.put(`/audit_reports/${connectedOrg}/date_range/${year_id}/update_date_range`, payload);
      NotificationManager.success(t("Updated successfully"));
    } catch (error) {
      NotificationManager.error(error?.response?.data?.error || t("Something went wrong"));;
    }
  };
  const fetchData = async () => {

    try {
      const auditDateRange = await client.get(`/audit_reports/${connectedOrg}/date_range/${year_id}`);
      setDateRange(auditDateRange.data);
    } catch (error) {
      NotificationManager.error(error?.response?.data?.error || t("Something went wrong"));
    }
  };

  const fetchAllFilesData = async () => {
    let updated_data = {
      account_file: []
    };
    try {
      if (request_during_audit_id !== "new") {
        const files_data = await client.get(`/audit_reports/${connectedOrg}/during_audit/${year_id}`);
        if (files_data?.data?.account_file) {
          files_data.data?.account_file.map(requirement => {
            updated_data.account_file.push({
              ...requirement,
              updated_at: files_data?.data?.updated_at
            })
          });
          reset({ ...files_data.data, ...updated_data });
        };
      };
    } catch (error) {
      NotificationManager.error(error?.response?.data?.error || t("Something went wrong"));
    }
  };
  const filteredFields = fields.filter((row) => {
    const isCompleted = row?.audit_requirements_account?.[0]?.upload_file;
    if (filter === 'Completed') return isCompleted;
    if (filter === 'Not Completed') return !isCompleted;
    return true;
  });

  return (
    <Page title={t("Request During Audit")}>
      <div className='d-flex justify-content-between align-items-center'>
        <BackButton />
      </div>
      <div>
        {auditDateRange &&
          <>
            <div className="">
              <LocalForm initialState={auditDateRange} onSubmit={handleUpdateDateRange}>
                <div className="row">
                  <div className='d-flex justify-content-between ml-3'>
                    <UpdateFormGroup label="Company Name" className="mr-3">
                      <Control.text
                        model=".connectedsation"
                        className="form-control"
                        readOnly
                        defaultValue={selectedOrganisation?.name}
                      />
                    </UpdateFormGroup>
                    <UpdateFormGroup label="Audit start date" className="mr-3">
                      <DatePicker
                        type="date"
                        className="form-control"
                        model=".start_date"
                        disabled={auditor_permission === false}
                      />
                    </UpdateFormGroup>
                    <UpdateFormGroup label="Deadline" className="mr-3">
                      <DatePicker
                        type="date"
                        className="form-control"
                        model=".deadline"
                        disabled={auditor_permission === false}
                      />
                    </UpdateFormGroup>
                    <UpdateFormGroup label="&nbsp;">
                      <Button disabled={auditor_permission === false} color="primary" type="submit"><Trans>Save</Trans></Button>
                    </UpdateFormGroup>
                  </div>
                </div>
                <div className="row my-2">
                  <div className="col">
                    <span className=""> <strong><Trans>Audit period end date</Trans></strong> : {auditDateRange?.end_date}</span>
                  </div>
                </div>
              </LocalForm>
            </div>
            <hr className='my-4' />
          </>
        }
        {progress > 0 ? (
          <div className="progress my-3 h-50">
            <div className="progress-bar h-50  progress-bg-clr" role="progressbar" style={{ width: `${progress}%` }}>
              {progress}%
            </div>
          </div>
        ) :
          <div className="progress my-3 h-50">
            <div className="progress-bar h-50  progress-bg-clr" role="progressbar">
              {0}%
            </div>
          </div>
        }
        <Row className="my-3">
          <Col md="4">
            <UpdateInput
              type="select"
              name="filterSelect"
              value={filter}
              onChange={e => setFilter(e.target.value)}
            >
              <option onClick={() => setFilter('')}>{t('All')}</option>
              <option onClick={() => setFilter('Completed')}>{t('Completed')}</option>
              <option onClick={() => setFilter('Not Completed')}>{t('Not Completed')}</option>
            </UpdateInput>
          </Col>
        </Row>
        <FormProvider {...methods}>
          <Table>
            <thead>
              <tr>
                <th className="text-center"><Trans>File Name</Trans></th>
                <th className="text-center"><Trans>Comment</Trans></th>
                <th className="text-center"><Trans>Valid</Trans></th>
                <th className="text-center"><Trans>Upload</Trans></th>
                <th className="text-center"><Trans>Status</Trans></th>
                <th className="text-center"><Trans>Actions</Trans></th>
                <th className="text-right" />
              </tr>
            </thead>
            <tbody>
              {filteredFields.map((row, index) => {
                const n = (v) => `account_file.${index}.${v}`;

                return (
                  <tr key={row?.key}>
                    <td className="text-center align-middle">
                      <FormGroup>
                        <Input
                          type="text"
                          className="form-control"
                          name={n("file_name")}
                          placeholder="File Name"
                        />
                      </FormGroup>
                    </td>
                    <td className="text-center align-middle">
                      <FormGroup>
                        <Input
                          type="text"
                          className="form-control"
                          name={n("request_during_audit_comment")}
                          placeholder="Comment"
                        />
                      </FormGroup>
                    </td>
                    <td className="text-center">
                      <FormGroup className="d-flex justify-content-center align-items-center">
                        <Input
                          type='checkbox'
                          name={n("is_required")}
                          checked={getValues(n("is_required"))}
                          disabled={auditor_permission === false}
                        />
                      </FormGroup>
                    </td>
                    <td className="text-right align-middle">
                      <FormGroup>
                        <InputFilesForm t={t} getData={getValues} name={n(`audit_requirements_account`)} setValue={setValue} indx={index} control={control} onFilesCountUpdate={(count) => handleFilesCountUpdate(count, setUploadedFilesCount, index)} uploadedFilesCount={uploadedFilesCount[index] || 0} auditor_permission={auditor_permission}></InputFilesForm>
                      </FormGroup>
                    </td>
                    <td className="text-center">{row?.audit_requirements_account?.[0]?.upload_file ? 'Completed' : 'Incomplete'}</td>
                    <td className="text-center align-middle">
                      <div className="d-flex justify-content-center">
                        <Button color="danger" onClick={() => remove(index)}>
                          <i className="fa fa-trash"></i>
                        </Button>
                      </div>
                    </td>

                  </tr>
                )
              })}
            </tbody>
          </Table>
          <FormGroup className="text-right d-flex justify-content-between align-items-center">
            <Button color="success" onClick={addRow}>+ <Trans>Add a new file</Trans></Button>
            <Button type="submit" color='primary' onClick={handleSubmit(handleRequestSubmit)}><Trans>Submit</Trans></Button>
          </FormGroup>
        </FormProvider>
      </div>
    </Page>
  );
};

export default RequestDuringAudit;
